import type { ApplicationConfig } from './ApplicationConfig';
import { Stage } from './ApplicationConfig';

export const prodConfig: ApplicationConfig = {
  apiUrl: 'https://api.skin-seoul.com',
  apiKey: '55930ae6-9ed5-4e63-92a0-bd91fec26a45',
  stage: Stage.PROD,
  sheetId: '1ffxiNtrot1kCAcAVPov4mi2V7rmPRsVwd5wX5x9jv3U',
  wpAdminUrl: 'https://skin-seoul.com/wp-admin/',
  adminUrl: 'https://admin.skin-seoul.work',
};
